export default __webpack_public_path__ + "static/media/icon--add.349acf7c.svg";